/*
  Redeluxe product carousel (sections/section-product-carousel.liquid).
  The row itself is a native CSS scroll-snap track (touch swiping, trackpad, keyboard).
  This file only adds: previous / next arrows, the thin progress line and the "04 / 08" counter.
  No autoplay, no third-party library.
*/
(function () {
  if (window.__rxCarouselReady) return;
  window.__rxCarouselReady = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  // Phones: the theme shortens long names with its own chevron. Inside these carousels we show the full name
  // and let CSS cut it to two lines with an ellipsis instead (the name stays in the title attribute).
  var phone = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  function tidyTitles(scope) {
    if (!phone || !phone.matches) return;
    var titles = (scope || document).querySelectorAll('[data-rx-carousel] [data-title], [data-rx-carousel] [data-title-ready]');
    for (var i = 0; i < titles.length; i++) {
      var el = titles[i];
      var full = el.getAttribute('title');
      if (!full) continue;
      el.removeAttribute('data-title');
      el.removeAttribute('data-title-ready');
      el.classList.remove('is-title-expanded');
      el.textContent = full;
    }
  }

  function init(root) {
    if (!root || root.getAttribute('data-rx-ready')) return;
    var track = root.querySelector('[data-rx-track]');
    var slides = root.querySelectorAll('[data-rx-slide]');
    var prev = root.querySelector('[data-rx-prev]');
    var next = root.querySelector('[data-rx-next]');
    var bar = root.querySelector('[data-rx-bar]');
    var counter = root.querySelector('[data-rx-counter]');
    if (!track || !slides.length) return;
    root.setAttribute('data-rx-ready', '1');

    var ticking = false;

    function metrics() {
      var first = slides[0].getBoundingClientRect().width;
      var cs = window.getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      var step = first + gap;
      // Cards fully inside the row (a peeking sliver does not count).
      var perView = Math.max(1, Math.floor((track.clientWidth + gap + 2) / step));
      return { step: step, perView: perView };
    }

    function update() {
      ticking = false;
      var m = metrics();
      var max = track.scrollWidth - track.clientWidth;
      var pos = track.scrollLeft;
      var atStart = pos <= 2;
      var atEnd = pos >= max - 2;
      var total = slides.length;
      var firstIndex = Math.round(pos / m.step);
      var lastVisible = atEnd ? total : Math.min(total, firstIndex + m.perView);

      if (counter) counter.textContent = pad(lastVisible) + ' / ' + pad(total);
      if (bar) {
        var scrollW = track.scrollWidth || 1;
        var width = Math.min(100, (track.clientWidth / scrollW) * 100);
        var left = Math.min(100 - width, (pos / scrollW) * 100);
        bar.style.width = width + '%';
        bar.style.left = left + '%';
      }
      if (prev) prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      if (next) next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    function go(direction) {
      var m = metrics();
      track.scrollBy({ left: direction * m.step * m.perView, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', requestUpdate, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    window.addEventListener('resize', requestUpdate);
    update();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-rx-carousel]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
    tidyTitles();
    window.addEventListener('load', function () { tidyTitles(); window.setTimeout(tidyTitles, 700); });
    if (phone && phone.addEventListener) phone.addEventListener('change', function () { tidyTitles(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  // Used by assets/redeluxe-empty-cart.js when it builds a carousel after page load.
  window.rxCarousel = { init: init, tidy: tidyTitles };

  // Theme editor: re-initialise when a section is added or re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) {
      var r = e.target.querySelector ? e.target.querySelector('[data-rx-carousel]') : null;
      if (r) init(r);
    }
  });
})();
